import React from 'react';
import _ from 'underscore';

import { Formatters, Messages } from '../../codegen/Localize';
import { HelpService } from '../../commonInfra/services/HelpService';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { GetWorkerProcessStatus, IGetWorkerProcessStatusResult, WorkerStatusType } from '../types/GetWorkerProcessStatus';
import { WorkerProcess, WorkerProcessType } from '../types/WorkerProcess';
import { messagesMap } from './ServerStatus';

export interface ProcessStatusProps {
    process: WorkerProcess;
    isPreferred: boolean;
}

export interface ProcessStatusState {
    status: string;
}


export class WorkerProcessStatus extends React.PureComponent<ProcessStatusProps, ProcessStatusState> {
  mounted: boolean = true;
  pending: number = 0;
  syncTimestamp: string = null;

  constructor(props: ProcessStatusProps) {
    super(props);
    this.state ={
      status: null,
    };
}

  public componentDidMount(){
    this.renderStatus();
  }

  public componentDidUpdate() {
    this.renderStatus();
  }
  // To avoid react state update once the component is unmounted.
  public componentWillUnmount() {
    this.mounted = false;
  }

  private renderStatus = (): void => {
        if (this.props.process.isExternal) {
          this.pending = 0;
          // External Services don't monitor the status.
          this.setState({status:  WorkerStatusType.external});
          return;
        }

        WebHttpClient.sendRequest(new GetWorkerProcessStatus({process: this.props.process}))
          .then((result: IGetWorkerProcessStatusResult) => {
            if(this.mounted) {
              this.pending =  result.pendingTransfers;
              this.syncTimestamp = result.syncTimestamp;
              this.setState({status:  result.status});
            }
          });
  };


  private showStatusText = (): boolean => {
    const status: string = this.state.status;
    switch(this.props.process.type) {
      case WorkerProcessType.clusterController:
        return status === WorkerStatusType.down;
      case WorkerProcessType.fileStore:
        return _.contains([
            WorkerStatusType.activeSyncing,
            WorkerStatusType.down,
            WorkerStatusType.decommissioningReadOnly,
            WorkerStatusType.decommissionFailedReadOnly,
            WorkerStatusType.readyForRemoval
          ], status);
      case WorkerProcessType.repository:
        return status === WorkerStatusType.notAvailable;
      default:
        return false;
    }
  };

  private statusText = (): string => {
    const processStatus = this.props.process.type + '_' + this.state.status + '_status';
    const processStatusTextFn = messagesMap[processStatus];
    return processStatusTextFn ? processStatusTextFn(): '';
  };

  private statusTooltip = (): string => {
    if (this.pending > 0 || this.state.status === WorkerStatusType.activeSyncing) {
      return  Messages.filestore_activesyncing_tooltip({
        PENDING_COUNT: this.pending,
        PENDING_COUNT_LOC: Formatters.formatCount(this.pending)
      });
    } else {
      const inconToolTip = this.props.process.type + '_' + this.state.status + '_tooltip';
      const processStatusTooltipFn = messagesMap[inconToolTip];
      return processStatusTooltipFn ? processStatusTooltipFn() : '';
    }
  };

  private statusIconType = (): string => {
    switch(this.state.status) {
      case WorkerStatusType.active:
      case WorkerStatusType.decommissionFailedReadOnly:
      case WorkerStatusType.readyForRemoval:
        return WorkerStatusType.active;
      case WorkerStatusType.passive:
      case WorkerStatusType.readOnly:
        return WorkerStatusType.passive;
      case WorkerStatusType.busy:
      case WorkerStatusType.activeSyncing:
      case WorkerStatusType.decommissioningReadOnly:
      case WorkerStatusType.notAvailable:
        return WorkerStatusType.busy;
      case WorkerStatusType.unlicensed:
      case WorkerStatusType.down:
      case WorkerStatusType.statusNotAvailable:
      case WorkerStatusType.external:
        return this.state.status;
    }
  };

  private serverStatusHelpUrl = HelpService.getServerHelpUrlByCategory('status1');

  public render(): JSX.Element {
    return (
    <span>
      {this.state.status ?
      <span className="tb-data-grid-icon">
        <span className={'tb-icon-process-status tb-icon-process-status-'+this.statusIconType()} title={this.props.process.host+':'+this.props.process.port}/>
      </span>:  <span className="tb-icon-process-status tb-icon-spinner" />}
      {this.props.isPreferred ?
        <span className="tb-data-grid-cell-text tb-process-preferred-label"> {Messages.preferred()} </span> : ''}

      {this.showStatusText() &&
      <div className="tb-data-grid-cell-text" title={this.statusTooltip()}>
        <a href={this.serverStatusHelpUrl}> {this.statusText()} </a>
      </div>}

    </span>);
  }
}